var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 89.024,
    height: 89.024,
    viewBox: "0 0 89.024 89.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-tick-3960794",
    transform: "translate(-3.481 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9626",
    "data-name": "Path 9626",
    d: "M83.665,45.512A38.153,38.153,0,1,1,45.512,7.359,38.153,38.153,0,0,1,83.665,45.512Zm6.359,0A44.512,44.512,0,1,1,45.512,1,44.512,44.512,0,0,1,90.024,45.512ZM66.877,35A3.179,3.179,0,1,0,62.3,30.587L40.062,53.649,28.724,41.892a3.179,3.179,0,1,0-4.577,4.414L37.773,60.437a3.18,3.18,0,0,0,4.577,0Z",
    transform: "translate(2.481 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.2b98f85ba4ef75f28d5eb4e118bfd393.svg";
export { ForwardRef as ReactComponent };